import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export function Paragraph(props: { children: ReactNode; className?: string; as?: 'p' | 'div' }) {
	const Comp = props.as ?? 'p';
	return <Comp className={cn('text-muted-foreground mb-6', props.className)}>{props.children}</Comp>;
}
